import ApiService from './api.service'

const PlayerTagService = {
  index () {
    return ApiService.get('api/v1/admin/player-tags')
  },

  store (data) {
    return ApiService.postWithoutLoading('api/v1/admin/player-tags', data)
  },

  update (uuid, data) {
    return ApiService.putWithoutLoading(`api/v1/admin/player-tags/${uuid}`, data)
  },

  destroy (uuid) {
    return ApiService.deleteWithoutLoading(`api/v1/admin/player-tags/${uuid}`)
  }
}

export default PlayerTagService
